// extracted by mini-css-extract-plugin
module.exports = {"subscribeButton":"SubscribeButton-module_subscribeButton_82bae","size-small":"SubscribeButton-module_size-small_fdd38","star":"SubscribeButton-module_star_bfbd7"};